import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 26 }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y, filter: "blur(5px)" }}
        whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.7, delay, ease: "easeOut" }}
    >
        {children}
    </motion.div>
);
